import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useContext } from 'react';
import { Context } from '../../index';
import TeacherService from '../../services/TeacherService';
import { toast } from 'react-toastify';
import {FiSettings} from "react-icons/fi";

function SettingsPageT() {


  const { teacherstore } = useContext(Context);
  const navigate = useNavigate();
  const [isDeletePopupVisible, setDeletePopupVisible] = useState(false);

  const showDeletePopup = () => {
    setDeletePopupVisible(true);
  };

  const handleCancelClick = () => {
    setDeletePopupVisible(false);
  };

  const handleDeleteConfirm = async () => {
    try {
      const teacherId = teacherstore.teacher.id;
      const response = await TeacherService.delteach(teacherId);
      setDeletePopupVisible(false);
      teacherstore.setAuthT(false)
      // Optionally, navigate to a different page after deletion
      navigate('/');
      toast.success ('Ditt konto är nu raderad');
    } catch (error) {
    }
  };

  return (
    <div  className="center" style={{ maxWidth: '370px', margin: '0 auto', marginTop: '100px' }}>
      <h3 className="pt-32 pb-8 center flex"><FiSettings size={27} /></h3>
      <h3 className="mb-32 center">Dina kontoinställningar</h3>
        <button onClick={() => navigate('/mypassT')} className="buttonM">
          Byt lösenord
        </button>
        <button onClick={() => navigate('/mydetailsT')} className="buttonM">
          Dina uppgifter
        </button>

        <div className="center pt-64">
          <button onClick={showDeletePopup} className="ghostbuttonTeach">
            Radera mitt konto
          </button>
        </div>

        {/* Delete confirmation popup */}
        {isDeletePopupVisible && (
          <div className="popup-overlay">
            <div className="popupwarn p-32" style={{ textAlign: "center"}}>
              <h2>Varning! Du håller på att radera ditt konto!</h2>
                <p className='pt-8'>All din data kommer att raderas permanent!</p>
              <div className='mt-32 center' >
            <button onClick={handleDeleteConfirm} className="buttonRED">
               Jag samtycker, ta bort mitt konto
              </button>
              <button onClick={handleCancelClick} className="ghostbutton">
                Avbryt
              </button>
              </div>
         
            </div>
          </div>
        )}
      </div>
  );
}

export default SettingsPageT;


